import React, { useState, useContext, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";

import Button from "@material-ui/core/Button";

import SubscriptionModal from "../../components/SubscriptionModal";
import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";
import MainContainer from "../../components/MainContainer";
import { Section, StatusBadge } from "../../components/ui";
import moment from "moment";
import { useDate } from "../../hooks/useDate";
import { getTokens } from "../../styles/tokens";

import { AuthContext } from "../../context/Auth/AuthContext";

const useStyles = makeStyles((theme) => {
  const t = getTokens(theme.palette.type, theme.palette.primary.main);
  return {
    card: {
      maxWidth: 520,
      overflowY: "auto",
      ...theme.scrollbarStyles,
    },
    rows: { margin: 0, display: "flex", flexDirection: "column" },
    row: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      flexWrap: "wrap",
      gap: 8,
      padding: "12px 0",
      borderBottom: `1px solid ${t.lineRow}`,
      "&:first-child": { paddingTop: 0 },
    },
    term: {
      fontFamily: t.font,
      fontSize: 12.5,
      fontWeight: 600,
      color: t.textSecondary,
    },
    value: {
      margin: 0,
      minWidth: 0,
      fontFamily: t.font,
      fontSize: 14,
      color: t.text,
      textAlign: "right",
      overflowWrap: "anywhere",
    },
    hint: {
      display: "block",
      marginTop: 2,
      fontSize: 12,
      color: t.textSecondary,
    },
    cta: { marginTop: 18 },
  };
});

const Contacts = () => {
  const classes = useStyles();
  const { user } = useContext(AuthContext);

  const [loading,] = useState(false);
  const [, setPageNumber] = useState(1);
  const [selectedContactId, setSelectedContactId] = useState(null);
  const [contactModalOpen, setContactModalOpen] = useState(false);
  const [hasMore,] = useState(false);
  const [dueDate, setDueDate] = useState("");
  const { returnDays } = useDate();

  const handleOpenContactModal = () => {
    setSelectedContactId(null);
    setContactModalOpen(true);
  };

  const handleCloseContactModal = () => {
    setSelectedContactId(null);
    setContactModalOpen(false);
  };

  const loadMore = () => {
    setPageNumber((prevState) => prevState + 1);
  };

  const handleScroll = (e) => {
    if (!hasMore || loading) return;
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
    if (scrollHeight - (scrollTop + 100) < clientHeight) {
      loadMore();
    }
  };

  useEffect(() => {
    const currentDueDate = localStorage.getItem("dueDate");
    if (currentDueDate !== "" && currentDueDate !== "null") {
      setDueDate(moment(currentDueDate).format("DD/MM/YYYY"));
    }
  }, []);

  const days = returnDays(user?.company?.dueDate);
  const licenseText =
    days === 0 ? "Sua licença vence hoje!" : `Sua licença vence em ${days} dias!`;
  const licenseTone = days < 0 ? "error" : days <= 5 ? "warning" : "success";

  return (
    <MainContainer maxWidth>
      <SubscriptionModal
        open={contactModalOpen}
        onClose={handleCloseContactModal}
        aria-labelledby="form-dialog-title"
        contactId={selectedContactId}
      ></SubscriptionModal>

      <MainHeader>
        <Title>Assinatura</Title>
      </MainHeader>
      <Section className={classes.card} onScroll={handleScroll}>
        <dl className={classes.rows}>
          <div className={classes.row}>
            <dt className={classes.term}>Período de Licença</dt>
            <dd className={classes.value}>
              <StatusBadge color={licenseTone} label={licenseText} />
              {dueDate && dueDate !== "Invalid date" && (
                <span className={classes.hint}>Vencimento em {dueDate}</span>
              )}
            </dd>
          </div>
          <div className={classes.row}>
            <dt className={classes.term}>Email de cobrança</dt>
            <dd className={classes.value}>{user?.email}</dd>
          </div>
        </dl>
        <Button
          className={classes.cta}
          variant="contained"
          color="primary"
          onClick={handleOpenContactModal}
          fullWidth
        >
          Assine Agora!
        </Button>
      </Section>
    </MainContainer>
  );
};

export default Contacts;
